const state = {
    activeLink: ''
}

const getters = {
    activeLink: state => {
        return state.activeLink
    }
}

const actions = {
    updateActiveLink({commit}, payload) {
        commit('setActiveLink', payload)
    }
}

const mutations = {
    setActiveLink(state, payload) {
        state.activeLink = payload
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  